import { BaseServiceDefinition } from './BaseService';

class PriceListServiceDefinition extends BaseServiceDefinition {
  getPriceList(): Promise<any> {
    return this.get('/api/v1/pricelists');
  }

  downloadPriceFile(id: string, filename: string): Promise<any> {
    return this.downloadFile('/api/v1/pricelists/' + id, filename);
  }
}

export const PriceListService: PriceListServiceDefinition = new PriceListServiceDefinition();
